import * as React from "react"
import { useEffect } from "react"
import { endOfWeek } from "date-fns"
import { Alert, Box, Grid } from "@mui/material"
import { disabledAfter } from "@ui-seeker/core"

import { CATALOGUE_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { isSystemBusy } from "@signals"
import { resetCatalogueGeneral } from "./@signals"
import CatalogueGeneralFilters from "./Filters"
import CatalogueAnalyzerGroupedVsSiteTable from "./GroupedVsSiteTable"
import CatalogueAnalyzerNumPerRetailerChart from "./NumPerSiteChart"
import CatalogueGeneralNumProducstSiteChart from "./NumProductsSiteChart"
import CatalogueAnalyzerPriceNumProductsChart from "./PriceNumProductsChart"
import CatalogueAnalyzerShareProductsChart from "./ShareProductsChart"
import CatalogueAnalyzerTabs from "./Tabs"
import CatalogueAnalyzerMainSiteWarning from "./WarningMainSites"
import CatalogueAnalyzerOverviewTableWarning from "./WarningOverviewTable";


export default function CatalogueGeneralPage() {
    useEffect(() => {
        return () => resetCatalogueGeneral()
    }, [])

    const endOfSelectedWeek = endOfWeek(new Date(), { weekStartsOn: 1 })

    const props = {
        head: `DIP Insight | ${CATALOGUE_ROUTES.TITLE}`,
        title: CATALOGUE_ROUTES.TITLE,
        subtitle: CATALOGUE_ROUTES.SUBTITLE,
        isEmpty: false,
        filters: <CatalogueGeneralFilters />,
        hasErrors: isSystemBusy.value,
        tourPageKey: "catalogueGeneral",
        actionProps: {
            dateRangeProps: {
                hoverRange: "week",
                shouldDisableDate: disabledAfter(endOfSelectedWeek)
            }
        }
    }

    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12} >
                <Alert severity="info" sx={{ mb: 1 }}>
                    <Box>The information displayed in this section is only for Mondays.</Box>
                </Alert>
                <CatalogueAnalyzerOverviewTableWarning />
                <CatalogueAnalyzerMainSiteWarning />
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }} data-tour="catalogue-general-tabs">
                <CatalogueAnalyzerTabs />
            </Grid>

            <Grid item xs={6} data-tour="catalogue-general-num-retailer-chart">
                <CatalogueAnalyzerNumPerRetailerChart />
            </Grid>

            <Grid item xs={6}>
                <CatalogueAnalyzerShareProductsChart />
            </Grid>

            <Grid item xs={12} data-tour="catalogue-general-table">
                <CatalogueAnalyzerGroupedVsSiteTable />
            </Grid>

            <Grid item xs={12} data-tour="catalogue-general-num-products-chart">
                <CatalogueGeneralNumProducstSiteChart />
            </Grid>

            <Grid item xs={12} data-tour="catalogue-general-price-chart">
                <CatalogueAnalyzerPriceNumProductsChart />
            </Grid>
        </Grid>
    </PageWrapper>
}